export class DepositMainModel {
    label_title: string;
    label_bonus: string;
    label_payment_method: string;
    constructor() {
        this.label_title = "Deposit Money";
        this.label_bonus = "Select your bonus offer";
        this.label_payment_method = "Select your payment method";
    }
}

export class CasinoCageModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "Casino Cage";
    label_description_title: "";
    label_description: "<p>To make a direct deposit into your account from inside the Casino simply go to the Cashier and give them the amount you want to deposit, your Driver's License and the email address you used to access your account. The funds you deposit will be available immediately.</p><p>It's that easy!</p>";
}

export class CreditCardModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "Credit & Debit Card";
    label_description_title: "MasterCard Recommended";
    label_description: "We recommend MasterCard as many Visa card issuing banks do not allow these types of transactions. Enter Your Card Information, Your Billing Address and Press 'Submit'.";
    label_deposit_button: "Deposit";
    label_payment_title: "Amount";
    label_address: "Address";
    label_city: "City";
    label_state: "State";
    label_country: "Country"
    label_zipcode: "Zip code";
    label_message: "If your billing address is different from below, please enter it now";
    label_message_2: "To prevent fraud, your payment card’s billing address must match your address on file below. If your address is incorrect, please";
    label_text: "What is CVV Code?";
    label_input: "Name on the Card"
    label_input_1: "Select a Credit/Debit Card";
    label_input_2: "Use a different card";
    label_input_3: "Card Type";
    label_input_4: "Card Number";
    label_input_5: "Expiry Month";
    label_input_6: "Expiry Year";
    label_input_7: "CVV Code";
}

export class MazoomaModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "Online Banking";
    label_description_title: "";
    label_description: "";
}

export class PayNearMeModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "PayNearMe";
    label_description_title: "Please Note:";
    label_description: "<p><strong>Deposit Limit:</strong> 24 hr max: $500, 30 day max: $10,000</p><div style=\"font-size: 14px;\"><p><a href=\"https://home.paynearme.com\" target=\"_blank\">PayNearMe</a> lets you make deposits with cash at 7-Eleven or Family Dollar stores nationwide.</p><p>To use PayNearMe, select it as your funding method and follow the screen prompts to generate a barcode and payment instructions. You can either print out the barcode or display it on your mobile phone.</p><p>You then present the barcode, along with your cash, to complete the transaction at a participating <a href=\"https://home.paynearme.com/locations/\" target=\"_blank\">7-Eleven or Family Dollar.</a></p></div>";
}

export class PayPalModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "PayPal";
    label_description_title: "Please Note:";
    label_description: "<p>This option requires to turn off the \"Block Pop-ups\" option in the browser settings</p>";
}

export class PrePaidCardsModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "CanplayCasino Prepaid Card";
    label_description_title: "Please Note:";
    label_description: "<ul><li>Multiple Ways to Fund Visa, Mastercard, Discover, Pay With My Bank, and PayPal</li><li> Instant deposits to your CanplayCasino account</li><li>Fast cash-outs</li><li>Freedom to spend at retail and ATM's</li><li>Once enrolled select \"Add Funds\" to add funds your CanplayCasino Prepaid Card account</li></ul>";
}

export class VipPreferredModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "ACH/E-Check";
    label_description_title: "";
    label_description: "";
}

export class PayWithMyBankModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "PayWithMyBank";
    label_description_title: "PayWithMyBank TITLE";
    label_description: "PayWithMyBank DESCRIPTION";
}

export class CommonModel {
  label_title: "";
  label_bonus: "";
  label_payment_method: "";
  label_title_all: "Select another deposit method";
  label_title_limits: "Set your deposit limits";
}

export class InstaModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "INSTADEBIT";
    label_description_title: "INSTADEBIT TITLE";
    label_description: "INSTADEBIT DESCRIPTION";
  }
  export class ECheckModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "E-Check";
    label_description_title: "E-Check";
    label_description: "E-Check DESCRIPTION";
  }
  export class InteracModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "Interac";
    label_description_title: "Please Note:";
    label_description: '<p>This option requires to turn off the "Block Pop-ups" option in the browser settings</p>';
  }
  export class IDebitModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "Instant Bank Transfer - iDebit";
    label_description_title: "Instant Bank Transfer - iDebit TITLE";
    label_description: "Instant Bank Transfer - iDebit DESCRIPTION";
  }

  export class NeoSurfModel {
    label_title: "Deposit Money";
    label_bonus: "Select your bonus offer";
    label_payment_method: "NeoSurf";
    label_description_title: "NeoSurf ";
    label_description: "NeoSurf";
  }
